#import "../fragments/source-fragment.graphql"

mutation UpdateSource($source: SourceUpdateInput!) {
    sourceUpdate(input: $source) {
        source {
            ...SourceFragment
        }
    }
}
